import { Directive } from "vue"
import type { ImageProps } from "naive-ui"
import { getMediaSrc } from "@/shared/utils/mediaFunctions.ts"


export const vVideoSrc: Directive = {
	async created(el: HTMLVideoElement, binding) {
		getMediaSrc(binding.value.path).then(src => {
			el.src = src
		})
		getMediaSrc(binding.value.thumb).then(src => {
			el.poster = src
		})
	},
}

export const vImageSrc: Directive = {

	async created(el: ImageProps, binding) {
		getMediaSrc(binding.value).then(src => {
			el.src = src
		})
	},

}
